import api from "../../api/database";
import Vue from 'vue'


const state = {
    year: window.localStorage.getItem('reports_year'),
    program: window.localStorage.getItem('reports_program'),
    yearIndex: window.localStorage.getItem('reports_year_index'),
    data: "",
    formatedData: [],
    savedValues:[],
    extractedValues: [],
    unpostedValues: []
};

const getters = {
    currentYear: state => state.year,
    currentYearIndex: state => state.yearIndex,
    currentProgram: state => state.program,
    currentData: state => state.data,
    currentFormatedData: state => state.formatedData,
    currentSavedValues: state => state.savedValues,
    currentExtractedValues: state => state.extractedValues,
    currentUnpostedValues: state => state.unpostedValues
};

const actions = {
    async getData({commit}){
        //console.log("Print this")
        const response = await api.getProgramData(state.program,state.year);
        console.log(response)
        if(response && response['data']['status'] == "success"){
            console.log(`Success: ${state.program}`)
            console.log(`data: ${response['data']['data']['Item']}`)
            commit('setData', response['data']['data']['Item'])
            commit('setFormatedData', response['data']['formatedData'])
            commit('setSavedValues', response['data']['savedValues'])
            commit('setExtractedValues', response['data']['extractedValues'])
            commit('setUnpostedValues', response['data']['unpostedValues'])
        }
        else {
            console.log('Logging error')
            console.log(response)
            commit('setData', "Unable to fetch data")
        }
        
    },
    updateParams({commit}, model){
        console.log(`updating params. program: ${model.program}, year: ${model.year}`)
        commit('setProgram',model.program);
        commit('setYear',model.year)
        commit('setYearIndex',model.yearIndex)
        window.localStorage.setItem('reports_program',model.program);
        window.localStorage.setItem('reports_year',model.year);
        window.localStorage.setItem('reports_year_index',model.yearIndex);

    },
    async updateDB({commit}, obj){
        console.log(`obj: ${obj} in received in reports.js`)
        const response = await api.updateChangesToDB(state.program,state.year,obj.type,obj.body)
        console.log(response)
        if(response && response['data']['status'] == "success"){
            console.log(`Success: ${state.program}`)
            console.log(`data: ${response['data']['data']['Item']}`)
            commit('setData', response['data']['data']['Item'])
            commit('setFormatedData', response['data']['formatedData'])
            commit('setSavedValues', response['data']['savedValues'])
            commit('setExtractedValues', response['data']['extractedValues'])
            commit('setUnpostedValues', response['data']['unpostedValues'])
            Vue.notify({
                group: 'success',
                text: obj.isDeleteRequest ? `Deleted successfully` : `${obj.type} successful`,
                closeOnClick:true
                });
        }
        else {
            console.log('Logging error')
            console.log(response)
            Vue.notify({
                group: 'error',
                text: obj.isDeleteRequest ? `Failed to delete` : `Failed to ${obj.type}`,
                closeOnClick:true
                });
            //commit('setData', "Unable to fetch data")
        }

    }
    
};

const mutations = {
    setYear: (state, newYear) => {
        state.year = newYear;
    },
    setYearIndex: (state, newYear) => {
        state.yearIndex = newYear;
    },
    setProgram: (state, newProgram) => {
        state.program = newProgram;
    },
    setData: (state, newData) => {
        state.data = newData;
    },
    setFormatedData: (state, newData) => {
        state.formatedData = newData;
    },
    setSavedValues: (state, newData) => {
        state.savedValues = newData;
    },
    setExtractedValues: (state, newData) => {
        state.extractedValues = newData;
    },
    setUnpostedValues: (state, newData) => {
        state.unpostedValues = newData;
    }

}

export default {
    state,
    getters,
    actions,
    mutations
}
